var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpeechBubble = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80249 12.2368C3.51514 12.2368 4.95581 11.5447 6.04272 10.7705C9.66235 10.8372 12.3694 8.74536 12.3694 5.99731C12.3694 3.34668 9.71875 1.21387 6.41699 1.21387C3.11523 1.21387 0.469727 3.34668 0.469727 5.99731C0.469727 7.68408 1.51562 9.18628 3.12036 9.9707C2.8999 10.386 2.51025 10.9551 2.28979 11.2524C1.96167 11.6882 2.18726 12.2368 2.80249 12.2368ZM3.37671 11.1089C3.33057 11.1653 3.3562 11.2012 3.42285 11.1755C3.87915 10.991 4.79688 10.4167 5.41724 9.95532C5.62231 9.79639 5.78638 9.72974 6.00684 9.73486C6.10774 9.73486 6.19833 9.73658 6.27464 9.73803C6.33016 9.73908 6.37812 9.73999 6.41699 9.73999C9.14453 9.73999 11.3184 8.05835 11.3184 5.99731C11.3184 3.93628 9.14453 2.25977 6.41699 2.25977C3.68945 2.25977 1.51562 3.93628 1.51562 5.99731C1.51562 7.33545 2.4231 8.50952 3.98682 9.24268C4.31494 9.39648 4.36621 9.64258 4.2124 9.92456C4.02271 10.2834 3.63818 10.791 3.37671 11.1089Z",
    fill: "#E0E0E0"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpeechBubble);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Speech_Bubble.4cf4b1d3e65dbca0a20396f8d0dedfbb.svg";